export default "__VITE_PUBLIC_ASSET__778cbc79__"